// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import xOrderInformationStyles from "@keller/App/SharedStyle/MyAccount/Details/OrderInformationStyles";
import { associateNameStyles } from "@keller/App/Widgets/OrderDetails/OrderAssociateName";
import { css } from "styled-components";

associateNameStyles.wrapper = {
    ...xOrderInformationStyles.headingAndTextStyles?.wrapper,
};

associateNameStyles.titleText = {
    ...xOrderInformationStyles.headingAndTextStyles?.heading,
};

associateNameStyles.associateName = {
    size: 12,
    lineHeight: "18px",
    css: css`
        ${wrapInContainerStyles}
    `,
};
